<template>
  <div>
    <div
      class="progress-bar-wrapper"
      :style="`background-color: ${backgroundColor}`"
    >
      <div
        class="progress-bar"
        :style="
          `
            height: ${height}px; width: ${progress.spentTimePercentage}%;
            background-color: ${progressColor}
          `
        "
      ></div>
    </div>
    <div class="progress-dates">
      <div class="progress-start">{{ formatDate(start) }}</div>
      <div class="progress-end">
        {{ formatDate(end) }}
        <p class="x-small-semibold" v-if="endText">{{ endText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Progressbar',
  props: {
    backgroundColor: {
      type: String,
      default: '#DFE3E8',
    },
    progressColor: {
      type: String,
      default: '#36A3CA',
    },
    height: {
      type: Number,
      default: 12,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    endText: {
      type: String,
      required: false,
    },
  },
  methods: {
    diffInDays(start, end) {
      return moment(start).diff(moment(end), 'days');
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY').toUpperCase();
    },
  },
  computed: {
    progress() {
      const spentTime = this.diffInDays(this.start, new Date());
      const totalOfDays = this.diffInDays(this.start, this.end);
      const percentage = (spentTime * 100) / totalOfDays;

      return {
        spentTimePercentage: percentage > 100 ? 100 : percentage,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .progress-bar-wrapper {
    width: 100%;
    border-radius: 6px;
  }

  .progress-bar {
    border-radius: 6px;
  }

  .progress-dates {
    @extend .small-semibold;

    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    color: var(--gray-500);
  }

  .progress-end {
    text-align: right;
  }
</style>
